const state_array = {
    AL: 'Alabama',
    AK: 'Alaska',
    AS: 'American Samoa',
    AZ: 'Arizona',
    AR: 'Arkansas',
    AA: 'Armed Forces Americas',
    AE: 'Armed Forces Europe, Canada, Africa and Middle East',
    AP: 'Armed Forces Pacific',
    CA: 'California',
    CO: 'Colorado',
    CT: 'Connecticut',
    DE: 'Delaware',
    DC: 'District Of Columbia',
    FM: 'Federated States of Micronesia',
    FL: 'Florida',
    GA: 'Georgia',
    GU: 'Guam',
    HI: 'Hawaii',
    ID: 'Idaho',
    IL: 'Illinois',
    IN: 'Indiana',
    IA: 'Iowa',
    KS: 'Kansas',
    KY: 'Kentucky',
    LA: 'Louisiana',
    ME: 'Maine',
    MD: 'Maryland',
    MA: 'Massachusetts',
    MI: 'Michigan',
    MN: 'Minnesota',
    MS: 'Mississippi',
    MO: 'Missouri',
    MT: 'Montana',
    NE: 'Nebraska',
    NV: 'Nevada',
    NH: 'New Hampshire',
    NJ: 'New Jersey',
    NM: 'New Mexico',
    NY: 'New York',
    NC: 'North Carolina',
    ND: 'North Dakota',
    MP: 'Northern Mariana Islands',
    OH: 'Ohio',
    OK: 'Oklahoma',
    OR: 'Oregon',
    PA: 'Pennsylvania',
    PR: 'Puerto Rico',
    MH: 'Republic of Marshall Islands',
    RI: 'Rhode Island',
    SC: 'South Carolina',
    SD: 'South Dakota',
    TN: 'Tennessee',
    TX: 'Texas',
    UT: 'Utah',
    VT: 'Vermont',
    VI: 'Virgin Islands',
    VA: 'Virginia',
    WA: 'Washington',
    WV: 'West Virginia',
    WI: 'Wisconsin',
    WY: 'Wyoming',
};

export {state_array};

export const KEY_ORDER_INFO = "orderInfo";
export const KEY_ORDER_AFTER_SUCCESS_PAYMENT = "oderInfoAfterSuccessPayment";
export const KEY_ORDER_AFTER_PAYMENT = "oderInfoAfterPayment";
export const KEY_ORDER_AFTER_SUCCESS_UPSELL = "oderInfoAfterSuccessUpsell";

export const setItemSessionStorage = (key, value) => {
    if (!sessionStorage || !key) {
        return;
    }
    sessionStorage.setItem(key, JSON.stringify(value));
};
export const getItemSessionStorage = (key) => {
    if (!sessionStorage || !key) {
        return;
    }

    const value = sessionStorage.getItem(key);
    return JSON.parse(value);
};
export const removeItemSessionStorage = (key) => {
    if (!sessionStorage || !key) {
        return;
    }

    sessionStorage.removeItem(key);
};